// Short relative time formatter used in deck library + comments.
// Relative for ≤30 days, absolute date thereafter.
export function timeAgo(input) {
  if (!input) return '';
  const ts = new Date(input).getTime();
  if (!Number.isFinite(ts)) return '';
  const seconds = Math.floor((Date.now() - ts) / 1000);
  if (seconds < 45) return 'just now';
  if (seconds < 3600) return `${Math.max(1, Math.floor(seconds / 60))}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  const days = Math.floor(seconds / 86400);
  if (days < 30) return `${days}d ago`;
  return new Date(ts).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
